import React, { FC, useState, useEffect, memo } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import { changeDateFromUsToVn } from "../../utils/DateTimeUtils";
import { tienFormat } from "../../utils/NumberUtils";
import './cardCongNoChiTiet.scss'
import { GetNghiepVu } from "./congNoUtils";
import NhapSuaChungTu from "./nhapSuaChungTu";
type OwnProps = {
    cardData: any;
    onReloadData?: () => void;
    onEditChungTu: (chungTu: any) => void;
    onDeleteChungTu: (chungTu: any) => void;
}

const CardCongNoChiTiet: FC<OwnProps> = ({
    cardData,
    onReloadData,
    onEditChungTu,
    onDeleteChungTu,
}) => {
    const mb = cardData.mienBac
    const mt = cardData.mienTrung
    const mn = cardData.mienNam
    const [state, setState] = useState({
        editOen: false,

    })
    function handleEditClose() {
        setState(prev => ({ ...prev, editOen: false }))
        if (onReloadData) onReloadData()
    }
    return (
        <div className="card-cntt-container">
            <div className=" card-cnct-ngay">
                {changeDateFromUsToVn(cardData.ngay)}
            </div>
            <div className=" common-container-row">
                {mb > 0 &&
                    <div className="card-cnct-doanhthu lai">MB {tienFormat(mb, 1)}</div>
                }
                {mb < 0 &&
                    <div className="card-cnct-doanhthu lo">MB  {tienFormat(mb, 1)}</div>
                }
                {mt > 0 &&
                    <div className="card-cnct-doanhthu lai">MT  {tienFormat(mt, 1)}</div>
                }
                {mt < 0 &&
                    <div className="card-cnct-doanhthu lo">MT  {tienFormat(mt, 1)}</div>
                }
                {mn > 0 &&
                    <div className="card-cnct-doanhthu lai">MN  {tienFormat(mn, 1)}</div>
                }
                {mn < 0 &&
                    <div className="card-cnct-doanhthu lo">MN  {tienFormat(mn, 1)}</div>
                }
            </div>
            <div className="divider-line"></div>
            <div>
                {
                    cardData.chungTus && cardData.chungTus.map((it: any) => {
                        const [nv, color] = GetNghiepVu(it)
                        return (
                            <div className=" common-container-col">
                                <div className=" common-container-row border-bottom">
                                    <div className="common-container-row left-panel">
                                        <Button size="tiny" color="translucent" round
                                            onClick={() => onEditChungTu(it)}
                                        ><i className="icon icon-edit"></i></Button>
                                        <Button size="tiny" color="translucent" round
                                            onClick={() => onDeleteChungTu(it)}
                                        ><i className="icon icon-delete"></i></Button>

                                        {/* <NhapSuaChungTu isOpen={state.editOen} data={{ chungTu: it }} onClose={handleEditClose}></NhapSuaChungTu> */}
                                    </div>
                                    <div className="common-container-row right-panel">
                                        <div className={"card-cnct-" + color}>{tienFormat(it.soTien, 1)}</div>
                                        <div className="card-cnct-nghiep-vu">{nv}</div>
                                    </div>
                                </div>
                                <div className="common-container-row left-panel"><div>{it.noiDung}</div></div>
                                <div className="divider-line"></div>

                            </div>
                        )
                    })
                }

            </div>

        </div>
    )
}
export default memo(CardCongNoChiTiet)